 import _ from 'underscore';
 import uniqwith from 'lodash.uniqwith';
 import cloneDeep from 'lodash.clonedeep';
 import service from '../service/item';
 import CONSTANT from '../constant/item';
 import STATUS_CODE from '../constant/status_code';


 export default {
   getProductAttrsInfo({ commit }, { productId }) {
     return new Promise((resolve, reject) => service.getProductAttrsInfo(productId).then(
        (info) => {
          commit(CONSTANT.ITEM_GET_PRODUCT_ATTRS_SUCCESS, info);
          resolve(info);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_PRODUCT_ATTRS_ERROR, e);
          reject(e);
        },
      ));
   },

   getItemList({ commit }, data) {
     return new Promise((resolve, reject) => service.getItemList(data.type).then(
        (list) => {
          if (_.isEmpty(list)) {
            resolve([]);
            commit(CONSTANT.ITEM_GET_LIST_ERROR_EMPTY);
            return [];
          }
          resolve(list);
          commit(CONSTANT.ITEM_GET_LIST_SUCCESS, list);
          return list;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_GET_LIST_ERROR, e);
        },
      ));
   },
   /**
    * 获取商品详情
    * @param {Object|number} payload 商品信息(对象或商品id)
    * @param {number} payload.productId 商品id(payload是对象的时候)
    * @param {number} payload.businessType 业务类型(payload是对象的时候)
    * @param {string} payload.businessCode 业务code(payload是对象的时候)
    */
   getItemDetail({ commit, state }, payload) {
     return new Promise((resolve, reject) => {
       let requestData = payload
       if (typeof payload !== 'object') {
         requestData = {
           productId: payload,
         }
         const itemList = state.itemDetailList;
         const item = _.find(itemList, v => v.productId === payload);
         if (!_.isEmpty(item)) {
           const cloneItem = cloneDeep(item);
           return resolve(cloneItem);
         }
       }
       return service.getItemDetail(requestData).then(
        (data) => {
          if (data === STATUS_CODE.PRODUCTS_NOT_EXIST) {
            commit(CONSTANT.ITEM_GET_DETAIL_NO_PRODUCT);

            return resolve({});
          }
          if (_.isEmpty(data)) {
            commit(CONSTANT.ITEM_GET_DETAIL_ERROR_EMPTY);
            return resolve({});
          }
          const cloneData = cloneDeep(data);
          commit(CONSTANT.ITEM_GET_DETAIL_SUCCESS, cloneData);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_DETAIL_ERROR, e);
          return reject(e);
        },
      );
     });
   },

   getItemDesc({ commit, state }, id) {
     return new Promise((resolve, reject) => {
       const descList = state.itemDescList;
       const desc = _.find(descList, v => v.id == id);
       if (desc && !_.isEmpty(desc.data)) {
         return resolve(desc.data);
       }
       return service.getItemDesc(id).then(
        (data) => {
          if (_.isEmpty(data)) {
            commit(CONSTANT.ITEM_GET_DESC_ERROR_EMPTY);
            return resolve({});
          }
          commit(CONSTANT.ITEM_GET_DESC_SUCCESS, {
            id,
            data,
          });
          return resolve(data);
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_GET_DESC_ERROR, e);
        },
      );
     });
   },

   getItemAttr({ commit, state }, options) {
     return new Promise((resolve, reject) => {
       const attrList = state.itemAttrList;
       const attr = _.find(attrList, v => v.productId == options.productId && v.attrType == options.attrType);
       if (!_.isEmpty(attr)) {
         return resolve(attr);
       }
       return service.getItemAttr(options).then(
        (data) => {
          if (_.isEmpty(data)) {
            commit(CONSTANT.ITEM_GET_ATTR_ERROR_EMPTY);
            return resolve({});
          }
          if (_.isEmpty(data.attrList)) {
            commit(CONSTANT.ITEM_GET_ATTR_ERROR_EMPTY);
            return resolve({});
          }
          const attrObj = _.extend(options, {
            data,
          });
          commit(CONSTANT.ITEM_GET_ATTR_SUCCESS, attrObj);
          return resolve(attrObj);
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_GET_ATTR_ERROR, e);
        },
      );
     });
   },
   getProductCityList({ commit }, data) {
     return new Promise((resolve, reject) => service.getProductCityList(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.ITEM_GETPRODUCTCITYLIST_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_GETPRODUCTCITYLIST_ERROR, e);
        },
      ));
   },
   checkDelivery({ commit }, data) {
     return new Promise((resolve, reject) => service.checkDelivery(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.ITEM_CHECKDELIVERY_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_CHECKDELIVERY_ERROR, e);
        },
      ));
   },
   queryAreaInfoByIds({ commit }, data) {
     return new Promise((resolve, reject) => service.queryAreaInfoByIds(data).then(
        (result) => {
          resolve(result);
          commit(CONSTANT.ITEM_QUERYAREAINFOBYIDS_SUCCESS, result);
          return result;
        },
        (e) => {
          reject(e);
          commit(CONSTANT.ITEM_QUERYAREAINFOBYIDS_ERROR, e);
        },
      ));
   },
   verifyOrder({ commit }, options) {
     return new Promise((resolve, reject) => service.verifyOrder(options).then(
        data => resolve(data),
        (e) => {
          reject(e);
        },
      ));
   },
   getStoreList({ commit }, data) {
     return new Promise((resolve, reject) => service.getStoreList(data).then(
        (data) => {
          commit(CONSTANT.ITEM_GET_STORE_LIST_SUCCESS, data);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_STORE_LIST_ERROR, e);
          reject(e);
        },
      ));
   },
   getStoreDetail({ commit }, data) {
     return new Promise((resolve, reject) => service.getStoreDetail(data).then(
        (data) => {
          commit(CONSTANT.ITEM_GET_STORE_DETAIL_SUCCESS, data);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_STORE_DETAIL_ERROR, data);
          reject(e);
        },
      ));
   },
   getSuitableCoupon({ commit }, data) {
     return new Promise((resolve, reject) => service.getSuitableCoupon(data).then(
        (data) => {
          commit(CONSTANT.ITEM_GET_SUITABLE_COUPON_SUCCESS, data);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_SUITABLE_COUPON_ERROR, data);
          reject(e);
        },
      ));
   },
   setCouponStatus({ commit }, data) {
     return new Promise((resolve, reject) => service.setCouponStatus(data).then(
        (res) => {
          commit(CONSTANT.ITEM_SET_SUITABLE_COUPON_SUCCESS, data);
          return resolve('ok');
        },
        (e) => {
          commit(CONSTANT.ITEM_SET_SUITABLE_COUPON_ERROR, e);
          reject(e);
        },
      ));
   },
   getRelatedProduct({ commit }, data) {
     return new Promise((resolve, reject) => service.getRelatedProduct(data).then(
        (data) => {
          commit(CONSTANT.ITEM_GET_RELATED_PRODUCT_SUCCESS, data);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_RELATED_PRODUCT_ERROR, data);
          reject(e);
        },
      ));
   },
   getLookRelatedProduct({ commit }, data) {
     return new Promise((resolve, reject) => service.getLookRelatedProduct(data).then(
        (data) => {
          commit(CONSTANT.ITEM_GET_LOOK_RELATED_PRODUCT_SUCCESS, data);
          return resolve(data);
        },
        (e) => {
          commit(CONSTANT.ITEM_GET_LOOK_RELATED_PRODUCT_ERROR, data);
          reject(e);
        },
      ));
   },

  /*yeoman-template-point-1*/
 };
